function parseGradientBackground ({
	type = 'solid',
	color = '#ffffff',
	secondColor = '#000000',
	deg = 90,
	size = 100
}) {
	
	let styleObj = {
		backgroundColor: color
	}

	switch(type) {
		case 'linearGradient':
			styleObj['backgroundImage'] = `linear-gradient(${deg}deg, ${color}, ${secondColor})`
			break
		case 'radialGradient':
			styleObj['backgroundImage'] = `radial-gradient(${size}% ${size}%, ${color}, ${secondColor})`
	}

	return styleObj

}

export default parseGradientBackground
